import { createContext, useContext } from 'react';

export const HandHistorySnapshotModeContext = createContext(false);

export const useHandHistorySnapshotMode = () => useContext(HandHistorySnapshotModeContext);
